import React, { useEffect, useState } from "react";
import Boardcard from "../../Components/Boardcard/Boardcard";
import ButtonPagenate from "../../Components/ButtonPagenate/ButtonPagenate";
import Navbar from "../../Components/Navbar/navbar";
import Topbarsub from "../../Components/Topbar/Topbarsub";
import "../Employee/employee.css";
import RegionList from "./RegionList";
import { GrEdit } from "react-icons/gr";
import { AiFillDelete } from "react-icons/ai";
import { StaffFilter } from "../ListFunction/listfunction";

const Region = ({ page, addnewoverlay, empselect }) => {
  const [searchcriteria, setSearchcriteria] = useState("");
  const [region, setRegion] = useState(empselect.allRegions);
  const [nameSearch, setNameSearch] = useState("");

  const [pageNumber, setPageNumber] = useState(0);
  //   const [loading, setLoading] = useState(true)
  //   const [ confirmresponse, setConfirmresponse] = useState(0)

  const itemsPerpage = 8; //Number of items to be displayed per page
  const pageCount = Math.ceil(region.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;

  // const totalCountry = region.length;
  //   const API = 'https://admin.sabrecwa.com/backend'

  const handleSearchCriteria = (incoming) => {
    setSearchcriteria(incoming);
  };

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleAddNewEmp = () => {};

  const filterSearch = (incoming) => {
    setNameSearch(incoming.toString());
  };

  var EmployeeLists = region.filter((filteredItem) => {
    if (searchcriteria === "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria === "" && nameSearch !== "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch !== "") {
      if (searchcriteria === "Fullname") {
        if (
          filteredItem.firstname
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Region") {
        if (
          filteredItem.department
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else {
        return filteredItem;
      }
    }
  });

  const newPagenum = (num) => {
    setPageNumber(num);
  };

  const handleDelete = (incoming) => {
    console.log(incoming);
    // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  };

  const handleEdit = (incoming) => {
    addnewoverlay(incoming);
    console.log(incoming);
    // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  };

  const handleaddOverlay = (incoming) => {
    addnewoverlay(incoming);
  };

  useEffect(() => {
    handleWidth();
  }, []);

  const [widthval, setWidthval] = useState({
    pie1: 0,
  });

  const handleWidth = () => {
    setWidthval({ pie1: region.length });
  };

  return (
    <div className="employee-container">
      <Navbar tabtext="Regions" currentab="others" />
      <Topbarsub
        serchCriteria={handleSearchCriteria}
        newEmployee={handleAddNewEmp}
        currrenTab={page}
        searchword={filterSearch}
        addoverlay={handleaddOverlay}
      />
      <div className="tretapp-card-container">
        <Boardcard
          val={widthval.pie1}
          name="Total Regions"
          maxV={15}
          minV={0}
        />
      </div>

      <div className="tretapp-list-submitted">
        <div className="tapp-list-title-container">
          <span id="tapp-list-title">Region List</span>
        </div>
        <div className="comp-list-table-containerr">
          <table>
            <thead>
              <tr>
                <th scope="col">#ID</th>
                <th scope="col">Region</th>
                <th scope="col">Director</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {EmployeeLists.slice(
                pagesVisited,
                pagesVisited + itemsPerpage
              ).map((items) => (
                <tr>
                  <td data-label="#ID">{items.ID}</td>
                  <td data-label="Region">{items.name}</td>
                  <td data-label="Director">
                    {StaffFilter(empselect, items.director)}
                  </td>
                  <td data-label="Action">
                    <GrEdit
                      onClick={() =>
                        handleEdit({ tag: "newregion", ID: items.ID })
                      }
                      id="butn-action"
                    />
                    <AiFillDelete
                      onClick={() => handleDelete(items.ID)}
                      id="butn-action"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="papp-table-pgnate-contain">
            <button
              id="addbitn"
              onClick={() => handleaddOverlay({ tag: "newcountry" })}
            >
              Add
            </button>
            <ButtonPagenate
              updatedPageNum={newPagenum}
              pageCount={pageCount}
              pageNumber={pageNumber}
              previousLabel="Prev"
              nextLabel="Next"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Region;
